import { useEffect, useState } from 'react';
import axios from 'axios';
import { DateTime } from 'luxon';
import { getTopicLessons } from '../../students/workspace/lessonTopicsApi';
import LessonDetailModal from '../../students/LessonDetailModal';
import IconStudent from '../../../components/icons/IconSudent';
import IconClock from '../../../components/icons/IconClock';
import '../../../css/lesson-topic-link.css';

function isPast(lesson) {
   if (!lesson.date) return false;
   const end = DateTime.fromFormat(lesson.date + ' ' + (lesson.end || lesson.start || '23:59'), 'yyyy-MM-dd HH:mm');
   return end.isValid && end < DateTime.now();
}

// Read-only "which real lessons actually covered this topic" row, shown in
// the admin's own course-content preview (courses/Workspace.jsx's Перегляд
// tab, via TopicPreviewPanel.jsx) - unlike TopicLessonFlyout.jsx (the
// workspace/*, per-STUDENT add/remove picker), a Topic's lesson links are
// genuinely global (any student, no student field on LessonTopic itself),
// so this page - which has no single student in scope - only ever DISPLAYS
// them, styled like a lesson card (schedule module's own LessonCard.jsx),
// clicking straight into the same LessonDetailModal used everywhere else.
// Adding/removing links happens from LessonDetailModal's own header
// (LessonTopicFlyout.jsx) or a student's workspace, not from here.

function LessonBadge({ link, onOpen }) {
   const [participants, setParticipants] = useState(null);
   const lesson = link.lesson;

   useEffect(() => {
      axios.get('/api/events?lesson=' + lesson.id, { withCredentials: true })
         .then(response => setParticipants(Array.isArray(response.data) ? response.data : []))
         .catch(() => setParticipants([]));
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [lesson.id]);

   const date = lesson.date ? DateTime.fromISO(lesson.date).toFormat('dd.MM.yyyy') : '';
   const names = (participants || [])
      .map(ev => (ev.student ? ev.student.name + ' ' + ev.student.surname : ''))
      .filter(Boolean);

   return (
      <div className={'course-preview-lesson-badge' + (isPast(lesson) ? ' past' : '')} onClick={() => onOpen(lesson.id)}>
         <span className='course-preview-lesson-badge-icon'><IconClock style={{ fill: 'var(--secondarytext-color)', width: 12, height: 12 }} /></span>
         <span className='course-preview-lesson-badge-date'>{date}</span>
         <span className='course-preview-lesson-badge-time'>{lesson.start}{lesson.end ? '–' + lesson.end : ''}</span>
         {names.length > 0 ? (
            <span className='course-preview-lesson-badge-students'>
               <IconStudent fillColor='icon-blue' style={{ width: 12, height: 12 }} />
               {names.join(', ')}
            </span>
         ) : ''}
      </div>
   );
}

export default function TopicLessonBadges({ topicId }) {
   const [links, setLinks] = useState([]);
   const [openLessonId, setOpenLessonId] = useState(null);

   useEffect(() => {
      getTopicLessons(topicId)
         .then(response => setLinks(Array.isArray(response.data) ? response.data : []))
         .catch(() => setLinks([]));
   }, [topicId]);

   if (links.length === 0) return null;

   return (
      <div className='course-preview-lesson-badges'>
         {links.map(lt => <LessonBadge key={lt.id} link={lt} onOpen={setOpenLessonId} />)}
         <LessonDetailModal isOpen={!!openLessonId} lessonId={openLessonId}
            onClose={() => setOpenLessonId(null)} onSaved={() => {}} />
      </div>
   );
}
